import React, { useState } from 'react';

import { Box, Grid } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';

import Slider from '@mui/material/Slider';

import hemidalSilver from '../../assets/images/svg/heimdall-node-silver.svg';
import odinSilver from '../../assets/images/svg/odin-node-silver.svg';
import thorSilver from '../../assets/images/svg/thor-node-silver.svg';
import freyaSilver from '../../assets/images/svg/freya-node-silver.svg';

import hemidalGold from '../../assets/images/svg/heimdall-node-gold.svg';
import odinGold from '../../assets/images/svg/odin-node-gold.svg';
import thorGold from '../../assets/images/svg/thor-node-gold.svg';
import freyaGold from '../../assets/images/svg/freya-node-gold.svg';

import styles from './style.module.css';
import { useCashOutReward, useGetNodeNumber } from '../../hooks/token';
import { usePayFees, getNodeChecksum } from '../../hooks/masterOfCoin';
import { useGetAvgTax } from '../../hooks/bitfrostLibrary';

const nodesData = [
  {
    nonActive: hemidalSilver,
    active: hemidalGold,
  },
  {
    nonActive: freyaSilver,
    active: freyaGold,
  },
  {
    nonActive: thorSilver,
    active: thorGold,
  },
  {
    nonActive: odinSilver,
    active: odinGold,
  },
];

const CountPerTier = ({tier}) => {
  const numberOfNodes = useGetNodeNumber(tier);
  return (  
      <>{numberOfNodes?.data ? numberOfNodes?.data: 0}</>
  )
}

const AvgTaxTier = ({tier, nodes}) => {
  // const {data: avgTaxTier } = useGetAvgTax(nodes, tier);
  const {data: avgTaxTier, isLoading: isLoading2} = useGetAvgTax(nodes, tier);
  // const avgTaxTier = 2;
  return (<Box className={styles.tooltip_wrap}>
    <Slider
      size="small"
      defaultValue={0}
      className="_dot"
      aria-label="Small"
      value={avgTaxTier ? avgTaxTier: 0}
      valueLabelDisplay="auto"
      valueLabelFormat={(value) => (
        <Box className={styles.customTooltip}>
          <h5>Avg. Tax</h5> <h2>{value}%</h2>
        </Box>
      )}
    />
  </Box>)

}

const NodeCard = ({ tier, tierNodes, classes }) => {
  const { payFees } = usePayFees();
  const { cashOutReward, isLoading } = useCashOutReward(tier);
  const web3context = useSelector((state) => state.web3.web3context);
  const account = web3context?.account;
  
  
  const nodeIds = account
  ? tierNodes?.map((node) =>
      getNodeChecksum(node.name, node.createdAt, tier, account)
    )
  : [];

  return (
    <Box className={`${styles.hoverContent} ${classes.hoverContent}`}>
      <Box className={styles.buttons} onClick={() => {console.log(nodeIds);console.log(tier); payFees([nodeIds, tier]) }}>
        <p>PAY</p>
      </Box>
      <Box className={styles.divider}></Box>
      <Box className={styles.buttons} onClick={() => cashOutReward([undefined])}>
        <p>CLAIM</p>
      </Box>
    </Box>
  );
};


const Cards = ({nodes}) => {
  const { nodesData } = useSelector((state) => state.ui);
  const useStyles = makeStyles((theme) => ({
    hoverContent: {
      background: theme.palette.background.hoverBgPay,
      color: theme.palette.text.primary,
    },
  }));
  const classes = useStyles();
  const [activeNode, setActiveNode] = useState(null);
  const [showLabel, setShowLabel] = useState(false);

  return (
    <Grid container spacing={2} sx={{ alignItems: 'flex-start' }}>
      {nodesData.map((d, i) => {
        return (
          <Grid item xs={3}>
            <Box
              className={styles.mainBoxContainer}
              onMouseOver={() => setActiveNode((prev) => (prev === i ? i : i))}
              onMouseOut={() => setActiveNode(null)}
            >
              <Box className={styles.mainBox}>
                <img src={activeNode === i ? d.hoverImg : d.img} width={'79px'} alt="circle" />
                <p
                  style={{
                    fontSize: '24px',
                    lineHeight: '33px',
                    fontWeight: '33px',
                    color: 'white',
                  }}
                >
                  <CountPerTier tier={d.name.toUpperCase()}/>
                </p>
                <AvgTaxTier nodes={nodes} tier={d.name.toUpperCase()} />
              </Box>
              <NodeCard tier={d.name.toUpperCase()} tierNodes={nodes} classes={classes}/>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Cards;
